(function ($) {

    $(document).ready(function(){
        $(".section-vacancies #accordion .panel:first-child a").removeClass('collapsed').addClass('in').attr('aria-expanded', 'true');
        $(".section-vacancies #accordion .panel:first-child .panel-collapse").addClass('in').attr('aria-expanded', 'true');

        $('.panel-collapse').on('shown.bs.collapse', function (e) {
            let $panel = $(this).closest('.panel');
            $('html,body').animate({
                scrollTop: $panel.offset().top - 100
            }, 500);
        });
    });


})(jQuery);